import axiosInstance from 'api/axiosInstance';

export interface CANtrackStatus {
	Id: string;
	Title: string;
}

async function getStatuses(
	searchKeyword: string = '',
): Promise<CANtrackStatus[]> {
	const data = await axiosInstance.get(
		`/api/cantrackv3/Statuses?searchKeyword=${encodeURIComponent(searchKeyword)}`,
	);
	if (!data || !data.data) throw new Error('Failed to fetch statuses');
	return data.data;
}

export default getStatuses;
